const periods = {
  periodOne: ["2026-05-01 - 2026-05-21", "2025-09-22 - 2025-11-30"],
  periodTwo: ["2026-05-22 - 2026-06-09", "2026-09-16 - 2026-09-21"],
  periodThree: ["2026-06-10 - 2026-07-02", "2026-09-01 - 2026-09-15"],
  periodFour: ["2026-07-03 - 2026-08-31"],
  periodFive: ["2026-03-01 - 2026-04-30"],
  periodSix: ["2025-12-01 - 2025-12-28"],
  periodSeven: ["2026-01-03 - 2026-02-28"],
  periodEight: ["2025-12-29 - 2026-01-02"],
};

export default periods;
